import {FC, memo} from 'react'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {filterSelector, setFilterDelveryOrders} from '../../../redux/slices/filterSlices'
import {StyledButtonGroups} from '../../../components/StyledButtonGroups'
import {SelectPageSize} from '../../../components/SelectPageSize/SelectPageSize'
import { Spinner } from 'react-bootstrap'

interface ButtonGroupsProps {
  hasSync?: boolean
  isLoadingSync?: boolean
  setShowSync: (value: boolean) => void
}

export const ButtonGroups: FC<ButtonGroupsProps> = ({
  hasSync,
  isLoadingSync,
  setShowSync
}) => {
  const {filterDeliveryOrders: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const handlePageSizeChange = (value: number | null | undefined) => {
    dispatch(setFilterDelveryOrders({...filter, per_page: value ?? 5}))
  }

  return (
    <StyledButtonGroups
      leftContent={
        <SelectPageSize
          initialValue={filter?.per_page ?? 5}
          onChange={(value: any) => handlePageSizeChange(value?.value)}
        />
      }
      rightContent={
        <>
        {
          hasSync && <>
            <button
              className='btn btn-primary me-2'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title='Sync'
              onClick={() => setShowSync(true)}
              disabled={isLoadingSync}
            >
              {isLoadingSync ? <Spinner animation='border' variant='light' size='sm' /> : <>
                <i className='fas fa-refresh'></i> Sync
              </> }
            </button>
          </>
        }
        </>
      }
    />
  )
}
